import $ from 'jquery'
import '../assets/global/plugins/fancybox/source/jquery.fancybox.js'

export default {
  bind(el) {
    const $el = $(el)

    $el.fancybox()
  }
}
